import { Stack } from '@mui/material';

import AcadlyLogoSquareIcon from '../../../../../icons/AcadlyLogoSquare';
import AttendanceTitle from './AttendanceTitle';
import AttendanceAction from './AttendanceAction';

const Header = () => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
      <Stack direction="row" alignItems="center">
        <AcadlyLogoSquareIcon size={48} />
        <AttendanceTitle />
      </Stack>
      <AttendanceAction />
    </Stack>
  );
};

export default Header;
